{{#if active}}
    <li class="gHeader-main-nav-list-backLink js--action-closeToggle">Back</li>
    {{#each children}}
        {{#if children}}
            <li class="gHeader-subNav-list-item">
                <div class="gHeader-subNav-list-item__target js--action-revealSubMenu" onclick="gutenberg.close()">Paper Samples</div>

                <div class="gHeader-subNav-list-item__sub-menu-container">
                    <div class="gHeader-subNav-list-item__sub-menu">
                        <div class="gHeader-subNav-list-item__sub-menu__item">
                            <a href="/offering/paper-sample-book">
                                <div class="gHeader-subNav-list-item__sub-menu__item__media">
                                    <img src="https://spdc-assets.imgix.net/images/paper_sample_book_hero_16_9-20221003_115953735.jpg" alt="Sample Book"/>
                                </div>
                                <div class="gHeader-subNav-list-item__sub-menu__item__productDetails">
                                    <div class="gHeader-subNav-list-item__sub-menu__item__productName">Sample Book</div>
                                    <div class="gHeader-subNav-list-item__sub-menu__item__rate">FREE</div>
                                    Experience Smartpress' paper stock and weight options with a FREE Paper Sample Book.
                                    <div class="gHeader-subNav-list-item__sub-menu__item__href">Shop Now</div>
                                </div>
                            </a>
                        </div>
                        <div class="gHeader-subNav-list-item__sub-menu__item">
                            <a href="/offering/print-coating-sample-sheet">
                                <div class="gHeader-subNav-list-item__sub-menu__item__media">
                                    <img src="https://spdc-assets.imgix.net/images/print_coating_sample_sheet_hero-20210426_002600326.jpg" alt="Print &amp; Coating Sample Sheet"/>
                                </div>
                                <div class="gHeader-subNav-list-item__sub-menu__item__productDetails">
                                    <div class="gHeader-subNav-list-item__sub-menu__item__productName">Print &amp; Coating Sample Sheet</div>
                                    <div class="gHeader-subNav-list-item__sub-menu__item__rate">From $16.76</div>
                                    Review your colors, designs, image resolution and more with a Print and Coating Sample Sheet.
                                    <div class="gHeader-subNav-list-item__sub-menu__item__href">Shop Now</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        {{else}}
            <li><a href="{{ href }}">{{ label }}</a></li>
        {{/if}}
    {{/each}}
{{/if}}
